import { useEffect } from 'react';

export default function ViewportTracker() {
  useEffect(() => {
    fetch('/api/viewport', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        width: window.innerWidth,
        height: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio,
      }),
    }).catch(() => {});
  }, []);

  return null;
}
